import { create } from 'zustand'

interface IDrawerState {
  isOpen: boolean
  open: () => void
  close: () => void
}

const useMenuDrawerController = create<IDrawerState>()((set) => ({
  isOpen: false,
  open: () => set(() => ({ isOpen: true })),
  close: () => set(() => ({ isOpen: false })),
}))

export { useMenuDrawerController }
